angular.module('app.appMetaService', [])
.factory('appMetaService', [
  '$http', '$filter', 'PRODUCT',
  function ($http, $filter, product) {
    'use strict';

    let date = new Date();
    let cYear = date.getFullYear();
    
    switch (product.Code) {
      case "htv":
        return {
          logoUrl: ('assets/images/hockeytv-logo.png'),
          longName: 'HockeyTV',
          shortName: 'HTV',
          copyright: cYear + ' HockeyTech Inc.',
          website: 'HockeyTV.com',
          supportSite: 'http://support.hockeytv.com',
          supportEmail: 'support@hockeytv.com',
          passwordEmail: 'support@hockeytv.com'
        };
      case "ahl":
        return {
          logoUrl: ('assets/images/ahl/ahltv.png'),
          longName: 'AHLTV',
          shortName: 'AHL',
          copyright: cYear + ' AHLTV',
          website: 'ahltv.com',
          supportSite: 'http://support.ahltv.com',
          supportEmail: 'ahltv@theahl.com',
          passwordEmail: 'ahltv@theahl.com'
        };
    }
  }
]);



// WEBPACK FOOTER //
// ./app.v2/components/fhApp/appMetaService.js